import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMetaPixel, trackMetaPageView, getMetaPixelId } from '../utils/metaPixel.js';

/**
 * Initializes Meta Pixel and sends PageView on every route change.
 */
export default function MetaPixel() {
  const location = useLocation();

  useEffect(() => {
    if (!getMetaPixelId()) return;
    initMetaPixel();
  }, []);

  useEffect(() => {
    if (!getMetaPixelId()) return;
    initMetaPixel();
    // Skip duplicate PageView on first mount (init already fires one).
    if (!window.__invincibleMetaPixelPageReady) {
      window.__invincibleMetaPixelPageReady = true;
      return;
    }
    trackMetaPageView();
  }, [location.pathname, location.search]);

  return null;
}
